var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagTogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4307C24.8366 32.4307 32 25.2672 32 16.4307C32 7.59411 24.8366 0.430664 16 0.430664C7.16344 0.430664 0 7.59411 0 16.4307C0 25.2672 7.16344 32.4307 16 32.4307Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 0.430664C15.9888 0.430789 15.3048 6.83066 15.3048 6.83066H28.8012C25.8821 2.9446 21.2349 0.430664 16.0004 0.430664Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4308C21.2345 32.4308 25.8817 29.9168 28.8007 26.0308H3.19934C6.11834 29.9168 10.7655 32.4308 16 32.4308Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6801 13.2305H15.3048L16.0004 19.6305H31.6801C31.8901 18.5965 32.0004 17.5264 32.0004 16.4305C32.0004 15.3345 31.8899 14.2644 31.6801 13.2305Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19.6307C16 16.2915 16 4.18716 16 0.430664C7.1635 0.430664 0 7.59416 0 16.4307C0 17.5266 0.1105 18.5967 0.320375 19.6307H16Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82808 8.08301L9.86408 11.2714H13.2169L10.5046 13.2423L11.5405 16.4308L8.82808 14.4602L6.1157 16.4308L7.15177 13.2423L4.43945 11.2714H7.79214L8.82808 8.08301Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.430664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTogo);
export default __webpack_public_path__ + "static/media/flag_togo.81c668d714a051c0e1daa3a197e0cc90.svg";
export { ForwardRef as ReactComponent };